const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const eventsApi = {
  list:        (opts)        => request('/events',                { query: opts }),
  getBySlug:   (slug)        => request(`/events/${encodeURIComponent(slug)}`),
  adminList:   (token, opts) => request('/admin/events',          { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/events/${id}`,    { token }),
  adminCreate: (token, body) => request('/admin/events',          { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/events/${id}`,    { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/events/${id}`,    { method: 'DELETE', token }),
};

export const EVENT_CATEGORIES = [
  { id: 'all',           lbl: 'Toutes' },
  { id: 'religieux',     lbl: 'Religieux' },
  { id: 'culturel',      lbl: 'Culturel' },
  { id: 'sportif',       lbl: 'Sportif' },
  { id: 'communautaire', lbl: 'Communautaire' },
  { id: 'municipal',     lbl: 'Municipal' },
  { id: 'autre',         lbl: 'Autre' },
];

export const EVENT_RECURRENCES = [
  { id: 'unique',        lbl: 'Unique' },
  { id: 'hebdomadaire',  lbl: 'Hebdomadaire' },
  { id: 'mensuel',       lbl: 'Mensuel' },
  { id: 'annuel',        lbl: 'Annuel' },
];

export const CATEGORY_LABEL    = Object.fromEntries(EVENT_CATEGORIES.map((c) => [c.id, c.lbl]));
export const RECURRENCE_LABEL  = Object.fromEntries(EVENT_RECURRENCES.map((r) => [r.id, r.lbl]));
